import React, { useState, useEffect, useContext } from 'react';
import { Card, Col, Row, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import UserDropdownV2 from 'components/dropdowns/CustomerServices/UserDropdownV2';
import '../../../../../assets/scss/user.scss';
import dayjs from 'dayjs';
import 'react-datepicker/dist/react-datepicker.css';
import { Badge, Table } from 'react-bootstrap';
import AppContext from 'context/Context';
import TargetSettingModal from '../TargetSettingModal';
import MeasurableModal from '../MeasurableModal';
import { search, patch } from 'services/bs-sector-measurable/measurableService';
import { search as searchTarget } from 'services/bs-sector-measurable/targetService';
import { search as searchMeasureabledData } from 'services/bs-sector-measurable/measurableDataService';
import moment from 'moment';
import classNames from 'classnames';
import { buildTargetTextDisplay } from 'helpers/kpiHelper';
import isoWeek from 'dayjs/plugin/isoWeek';
import PropTypes from 'prop-types';
import Avatar from 'components/common/Avatar';
import { getUsername } from 'services/userServices';
import { MesuarableTdItem } from './MesuarableTdItem';
import DatePicker from 'react-datepicker';
import { defaultFormatTime } from 'helpers/kpiHelper';

export default function SectorCard({
  sector,
  setEditItem,
  setIsLoading,
  sheduleTypeText = 'Weekly',
  sheduleTypeId,
  isShowTodayParam = false
}) {
  const [isShowToday, setIsShowToday] = useState(isShowTodayParam);
  useEffect(() => {
    setIsShowToday(isShowTodayParam);
  }, [isShowTodayParam]);
  const typeMap = {
    Hourly: 'hour',
    Daily: 'day',
    Weekly: 'week',
    Monthly: 'month',
    Yearly: 'year'
  };
  dayjs.extend(isoWeek);
  const {
    config: { isDark }
  } = useContext(AppContext);
  dayjs.extend(require('dayjs/plugin/weekOfYear'));

  const [idEditing, setIdEditing] = useState(0);
  const [targets, setTargets] = useState([]);
  const [timesAgo, setTimesAgo] = useState([]);
  const [noOfCol, setNoOfCol] = useState(4);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedCurrentMonth, setSelectedCurrentMonth] = useState(
    dayjs(new Date()).startOf('month').toDate()
  );
  const [selectedSubOneMonth, setSelectedSubOneMonth] = useState(
    dayjs(new Date()).subtract(1, 'month').startOf('month').toDate()
  );

  const defaultInitialObj = {
    sectorId: sector.id
  };

  const [measurables, setMeasurables] = useState([]);
  const [initialMeasurables, setInitialMeasurables] = useState([]);

  useEffect(() => {
    calculateTimesAgo(selectedDate, sheduleTypeText, noOfCol);
    setSelectedCurrentMonth(
      new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1)
    );
    setSelectedSubOneMonth(
      dayjs(selectedDate).subtract(1, 'month').startOf('month').toDate()
    );
  }, [selectedDate, sheduleTypeText, noOfCol, isShowToday]);

  useEffect(() => {
    if (sector) {
      setMesurableData({ sectorId: sector.id });
      const noCol = sector.scheduleTypeText === 'Daily' ? 5 : 4;
      setNoOfCol(noCol);
      fetchInitialData();
    }
  }, [sector]);

  useEffect(() => {
    calculateMeasurables();
  }, [initialMeasurables, selectedCurrentMonth, timesAgo]);

  const handleSelectDate = date => {
    setSelectedDate(date);
  };

  const fetchInitialData = async () => {
    setIsLoading(true);
    try {
      let [resMeasurables, resTargets, mesuarableValuesRs] = await Promise.all([
        search({ isGetAll: true, sectorId: sector.id }),
        searchTarget({ isGetAll: true, sectorId: sector.id }),
        searchMeasureabledData({
          isGetAll: true,
          sectorId: sector.id,
          scheduleType: sector.scheduleType
        })
      ]);

      setTargets(resTargets);

      let mappedMeasurables = resMeasurables.items.map(x => ({
        ...x,
        dateData: mesuarableValuesRs?.items?.filter(
          mv => mv.measurableId == x.id
        )
      }));

      setInitialMeasurables(mappedMeasurables);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const calculateTimesAgo = (selectedDate, sheduleTypeText, noOfCol) => {
    const unit = typeMap[sheduleTypeText] || 'day';
    let times = [];

    // if Daily skip weekend
    if (unit === 'day') {
      let currentDate = dayjs(selectedDate);
      let dailyIndex = 0;
      console.log(isShowToday);
      if (isShowToday === true) {
        times.push({
          index: dailyIndex,
          date: currentDate.format(defaultFormatTime)
        });
      }
      for (let i = 0; i < noOfCol; ) {
        currentDate = currentDate.subtract(1, unit).startOf('day');

        if (currentDate.day() !== 0 && currentDate.day() !== 6) {
          times.push({
            index: dailyIndex + 1,
            date: currentDate.format(defaultFormatTime)
          });
          i++;
        }
        dailyIndex++;
      }

      times.reverse();
    } else {
      // Keep old loggic
      for (let i = noOfCol; i > 0; i--) {
        times.push({
          index: i,
          date: dayjs(selectedDate)
            .subtract(i, unit)
            .startOf(unit === 'week' ? 'isoWeek' : unit)
            .format(defaultFormatTime)
        });
      }
    }

    console.log(times);
    setTimesAgo(times);
  };

  const capitalizeFirstLetter = str => {
    const unit = typeMap[str] || 'day';
    return unit.charAt(0).toUpperCase() + unit.slice(1);
  };

  const calculateColName = date => {
    if (sheduleTypeText === 'Hourly') {
      return dayjs(date).format('DD-MMM hA');
    }
    if (sheduleTypeText === 'Monthly') {
      return dayjs(date).format('MMM-YYYY');
    }
    if (sheduleTypeText === 'Yearly') {
      return dayjs(date).format('YYYY');
    }
    return dayjs(date).format('DD-MMM');
  };

  const calculateMeasurables = () => {
    const updatedMeasurables = initialMeasurables.map(x => {
      let currentMonthTarget = targets.items.find(
        t =>
          t.measurableId == x.id &&
          new Date(t.date).getTime() === selectedCurrentMonth.getTime()
      );

      let previousMonthTarget = targets.items.find(
        t =>
          t.measurableId == x.id &&
          new Date(t.date).getTime() === selectedSubOneMonth.getTime()
      );

      const timeData = timesAgo.reduce((acc, time) => {
        acc[`time${time.index}`] = x.dateData.find(
          mv => dayjs(mv.date).format(defaultFormatTime) === time.date
        );
        return acc;
      }, {});

      return {
        ...x,
        ...timeData,
        currentMonthTarget,
        previousMonthTarget
      };
    });

    setMeasurables(updatedMeasurables);
  };

  const getMeasurables = async () => {
    setIsLoading(true);
    let resMeasurables = await search({ isGetAll: true, sectorId: sector.id });
    let resTargets = await searchTarget({
      isGetAll: true,
      sectorId: sector.id
    });
    let mesuarableValuesRs = await searchMeasureabledData({
      isGetAll: true,
      sectorId: sector.id,
      scheduleType: sector.scheduleType
    });
    let measurables = resMeasurables.items.map(x => {
      let currentMonthTarget = resTargets.items.find(
        t =>
          t.measurableId == x.id &&
          new Date(t.date).getTime() === selectedCurrentMonth.getTime()
      );

      let previousMonthTarget = resTargets.items.find(
        t =>
          t.measurableId == x.id &&
          new Date(t.date).getTime() === selectedSubOneMonth.getTime()
      );

      let mesuarableValues = mesuarableValuesRs?.items?.filter(
        mv => mv.measurableId == x.id
      );

      const timeData = timesAgo.reduce((acc, time) => {
        acc[`time${time.index}`] = mesuarableValues.find(
          mv => dayjs(mv.date).format(defaultFormatTime) === time.date
        );
        return acc;
      }, {});

      return {
        ...x,
        dateData: mesuarableValues,
        ...timeData,
        currentMonthTarget,
        previousMonthTarget
      };
    });
    setMeasurables(measurables);
    setIsLoading(false);
  };

  const [isMesurableShow, setIsMesurableShow] = useState(false);
  const [mesurableData, setMesurableData] = useState({});

  const toggleMesurabledModal = () => {
    setIsMesurableShow(!isMesurableShow);
  };

  const handleCloseMesurableModal = () => {
    setIsMesurableShow(false);
    setMesurableData({ ...defaultInitialObj });
  };

  const handleSubmitMesurableModal = () => {
    handleCloseMesurableModal();
    getMeasurables();
  };

  const [isTargetSettingShow, setIsTargetSettingShow] = useState(false);
  const [targetSettingData, setTargetSettingData] = useState({});

  const toggleTargetSettingdModal = () => {
    setIsTargetSettingShow(!isTargetSettingShow);
  };

  const handleCloseTargetSettingModal = () => {
    setIsTargetSettingShow(false);
    setTargetSettingData({});
  };

  const handleSubmitTargetSettingModal = () => {
    handleCloseTargetSettingModal();
    getMeasurables();
  };

  const handleSaveUserIncharge = (option, id) => {
    patch(id, { inChargeUserId: option.userId }).then(() => {
      setIdEditing(0);
      getMeasurables();
    });
  };

  return (
    <>
      <Card>
        <Card.Header
          className="d-flex justify-content-between align-items-center"
          style={{ paddingBottom: '0px' }}
        >
          <div className="d-flex align-items-center justify-content-between">
            <h3 className="me-2 mb-0">{sector.name}</h3>
            <FontAwesomeIcon
              size="xs"
              icon={faPencilAlt}
              style={{ cursor: 'pointer', marginRight: '25px' }}
              onClick={() => {
                setEditItem(sector);
              }}
            />
            <Col sm={2} style={{ marginRight: '15px', display: 'flex' }}>
              <Form.Select onChange={e => setNoOfCol(parseInt(e.target.value))}>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                {sector.scheduleTypeText !== 'Daily' ? (
                  <option selected value="4">
                    4
                  </option>
                ) : (
                  <>
                    <option value="4">4</option>
                    <option selected value="5">
                      5
                    </option>
                  </>
                )}
              </Form.Select>
            </Col>
            <Col sm={3}>
              <Form>
                <DatePicker
                  selected={selectedDate}
                  dateFormat="dd/MM/yyyy"
                  className="form-control model-data"
                  onChange={date => handleSelectDate(date)}
                />
              </Form>
            </Col>
          </div>
          <Button variant="outline-primary" onClick={toggleMesurabledModal}>
            Create
          </Button>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col sm={12}>
              <Table
                responsive
                borderless={true}
                style={{
                  backgroundColor: !isDark ? '#edf2f9' : '#0B1727',
                  borderRadius: '10px'
                }}
              >
                <thead>
                  <tr>
                    <th className="text-center" style={{ width: '5vw' }}>
                      #
                    </th>
                    <th style={{ width: '20vw' }}>Measurable</th>
                    <th className="text-center" style={{ width: '15vw' }}>
                      Target {moment(selectedSubOneMonth).format('MMM-YY')}
                    </th>
                    <th className="text-center" style={{ width: '15vw' }}>
                      Target {moment(selectedCurrentMonth).format('MMM-YY')}
                    </th>
                    <th
                      className="text-center"
                      style={{ width: idEditing > 0 ? '15vw' : '5vw' }}
                    >
                      #
                    </th>
                    <th className="text-center" style={{ width: '10vw' }}>
                      Variation Percentage
                    </th>
                    {timesAgo.map((time, index) => (
                      <th
                        key={index}
                        className="text-center"
                        style={{ width: '15vw' }}
                      >
                        <Badge style={{ fontSize: '12px' }}>
                          {calculateColName(time.date)}
                        </Badge>
                        <br />
                        {capitalizeFirstLetter(sheduleTypeText)} -{time.index}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {measurables?.map((x, index) => (
                    <tr key={index}>
                      <td className="text-center p-1">
                        <i>
                          <b>{index + 1}</b>
                        </i>
                      </td>
                      <td
                        className="p-1"
                        onClick={() => {
                          toggleMesurabledModal();
                          setMesurableData(x);
                        }}
                      >
                        {x.compareType == 1 ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip>{'Value < Target'}</Tooltip>}
                          >
                            <i>
                              <b>{x.name}</b>
                            </i>
                          </OverlayTrigger>
                        ) : (
                          <i>
                            <b>{x.name}</b>
                          </i>
                        )}
                      </td>
                      <td
                        className="text-center p-1"
                        onClick={() => {
                          toggleTargetSettingdModal();
                          setTargetSettingData({
                            ...x,
                            date: selectedSubOneMonth,
                            target: x.previousMonthTarget?.target
                          });
                        }}
                      >
                        {buildTargetTextDisplay(
                          x.targetTypeValue,
                          x.previousMonthTarget?.target?.toLocaleString(
                            'en-US'
                          ),
                          x.targetType,
                          x.numOfDecimal
                        )}
                      </td>
                      <td
                        className="text-center p-1"
                        onClick={() => {
                          toggleTargetSettingdModal();
                          setTargetSettingData({
                            ...x,
                            date: selectedCurrentMonth,
                            target: x.currentMonthTarget?.target
                          });
                        }}
                      >
                        {buildTargetTextDisplay(
                          x.targetTypeValue,
                          x.currentMonthTarget?.target?.toLocaleString('en-US'),
                          x.targetType,
                          x.numOfDecimal
                        )}
                      </td>
                      <td className={classNames('text-center p-1')}>
                        <div
                          onClick={() => setIdEditing(x.id)}
                          onBlur={() => setIdEditing(0)}
                        >
                          {x.id === idEditing ? (
                            <UserDropdownV2
                              fieldName="inChargeUserId"
                              handleChange={(_, option) =>
                                handleSaveUserIncharge(option, x.id)
                              }
                              placeholder=""
                              isMulti={false}
                              value={x?.inChargeUserId}
                            />
                          ) : (
                            <Avatar
                              size="xl"
                              name={getUsername(x?.inChargeUserId)}
                              className="me-2"
                            />
                          )}
                        </div>
                      </td>
                      <td className="text-center p-1">
                        {x.variationPercentage}%
                      </td>
                      {timesAgo.map((time, idx) => (
                        <MesuarableTdItem
                          key={idx}
                          sheduleTypeId={sheduleTypeId}
                          data={measurables}
                          item={x}
                          col={time.date}
                          value={x[`time${time.index}`]?.value?.toLocaleString(
                            'en-US'
                          )}
                          callback={getMeasurables}
                          noOfCol={noOfCol - time.index}
                          compareNoOfCol={noOfCol}
                        />
                      ))}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      {isMesurableShow && (
        <MeasurableModal
          measurables={measurables}
          isShow={isMesurableShow}
          handleClose={handleCloseMesurableModal}
          data={mesurableData}
          handleSubmit={handleSubmitMesurableModal}
        />
      )}
      {isTargetSettingShow && (
        <TargetSettingModal
          isShow={isTargetSettingShow}
          handleClose={handleCloseTargetSettingModal}
          data={targetSettingData}
          handleSubmit={handleSubmitTargetSettingModal}
        />
      )}
    </>
  );
}

SectorCard.propTypes = {
  sector: PropTypes.object,
  setEditItem: PropTypes.func,
  setIsLoading: PropTypes.func,
  sheduleTypeText: PropTypes.string,
  sheduleTypeId: PropTypes.number,
  isShowTodayParam: PropTypes.bool
};
